import { useState } from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import RadioLinkInput from 'hb-builder/components/common/SettingsLibrary/ComposedInputs/RadioLinkInput';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';
import type { PageImageItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/pageImageItemAttributess';

const Link = ({
  item,
  onChange,
}: Pick<
  ComponentSettingsTab<PageImageItemAttributes>,
  'item' | 'onChange'
>) => {
  const [value, setValue] = useState(item.attributes?.imageLink);

  const handleChange = ({ value }) => {
    setValue(value);

    onChange({
      id: item.id,
      settingKey: 'attributes.imageLink',
      value,
    });
  };

  return (
    <LinkWrapper>
      <RadioLinkInput
        id="imageSettingsContentLink"
        label={__('Link')}
        onChange={handleChange}
        value={value}
      />
    </LinkWrapper>
  );
};

export default Link;

const LinkWrapper = styled(Box).attrs(() => ({
  alignItems: 'center',
  justifyContent: 'space-between',
  mb: 4,
}))``;
